<script setup lang="ts">
import {Calendar, ChevronDown} from 'lucide-vue-next'
import {type Ref, ref} from 'vue'
import {label} from "../../mixins/translations";

interface Props{
    selectedTags: string[]
    pageSlug: string
    selectedSort: string
}
const props = defineProps<Props>();
const isSortOpen = ref(false)

const sortOptions = {
    'published_at|desc': label('site.knowledge.sort.desc'),
    'published_at|asc': label('site.knowledge.sort.asc')
}
const defaultSort = 'published_at|desc';
const selectedSort: Ref<string> = ref(props.selectedSort ?? defaultSort);

const selectSort = (sort) => {
    selectedSort.value = sort;
    isSortOpen.value = false;

    const params = new URLSearchParams();
    props.selectedTags.forEach(tag => {
        params.append('tag[]', tag);
    });

    if(selectedSort.value !== defaultSort){
        params.append('sort', selectedSort.value);
    }

    window.location = `${props.pageSlug}?${params.toString()}`;
}
</script>

<template>
    <div class="mb-6 flex justify-end mt-4">
        <div class="relative w-full sm:w-56">
            <button class="flex w-full items-center justify-between gap-3 rounded-md border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-50 transition" @click="isSortOpen = !isSortOpen">
                <div class="flex items-center gap-2">
                    <Calendar class="h-4 w-4 text-primary" />
                    <span>{{ sortOptions[selectedSort] }}</span>
                </div>

                <ChevronDown class="h-4 w-4 text-gray-400 transition-transform" :class="{ 'rotate-180': isSortOpen }"/>
            </button>
            <ul v-if="isSortOpen" class="absolute right-0 z-20 mt-2 w-full rounded-md border border-gray-200 bg-white shadow-lg">
                <li
                    v-for="(label, value) in sortOptions"
                    :key="value"
                    class="cursor-pointer px-4 py-2 text-sm hover:bg-gray-100"
                    @click="selectSort(value)"
                >
                    {{ label }}
                </li>
            </ul>
        </div>
    </div>
</template>
